import { useQuery } from "@tanstack/react-query";
import axiosPrivate from "../axiosPrivate";
import { getOrganizationSettings } from "../../utils/storage";

const APPID = process.env.REACT_APP_APPID;

export const useOrganizationSettings = () =>
  useQuery({
    queryKey: ["organizationSettings"],
    queryFn: async () => {
      const newOrg = getOrganizationSettings();

      console.log(newOrg, "New org things")

      const res = await axiosPrivate.get(`organizations/${newOrg.id}`);
      return res.data;
    },
    staleTime: 1000 * 60 * 10,
  });
